<template>
  <v-layout>
    <d-header fluid>
      <h1 class="title is-spaced">
        {{ $t("new_property") }}
      </h1>
    </d-header>

    <d-container paddingless-mobile fluid>
      <b-steps v-model="activeStep" :has-navigation="false">
        <b-step-item step="1" :label="$t('general_info')" :clickable="false" />
        <b-step-item step="2" :label="$t('pictures')" :clickable="false" />
        <b-step-item
          step="3"
          :label="$t('new_status_step')"
          :clickable="false"
        />
      </b-steps>

      <router-view :model="model" />
    </d-container>
  </v-layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
      __property: this.title // for breadcrumb
    };
  },
  data() {
    return {
      model: null
    };
  },
  computed: {
    title() {
      if (this.model && this.model.address) {
        return this.model.address.full_address;
      }
      return "";
    },
    activeStep() {
      if (this.$route.name == "properties.create.pictures") {
        return 1;
      }
      if (this.$route.name == "properties.create.status") {
        return 2;
      }
      return 0;
    }
  }
};
</script>
